import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { resolveShopSlugFromRoute } from '~/utils/resolveShopSlug'
import { isShopAdminPath, trackingLoadedForShop } from '~/utils/trackingScope'

type TrackingRoute = Pick<RouteLocationNormalizedLoaded, 'path' | 'params'>

export function useTrackingScope() {
  const router = useRouter()
  const { domainShopSlug } = useShopDomain()
  const { loadedForShop } = useSiteSettings()

  function shopSlugFor(route: TrackingRoute): string {
    return resolveShopSlugFromRoute(
      route.path,
      route.params as Record<string, string | string[]>,
      domainShopSlug.value,
    )
  }

  /**
   * Shop slug for `route` when its storefront tags may run there, otherwise ''.
   * Requires the loaded settings to belong to that shop, so a previous shop's
   * IDs are never initialised on the next one.
   */
  function trackableShop(route: TrackingRoute = router.currentRoute.value): string {
    const slug = shopSlugFor(route)
    if (!slug || isShopAdminPath(route.path, slug)) return ''
    if (loadedForShop.value !== slug) return ''
    const loadedFor = trackingLoadedForShop()
    if (loadedFor !== null && loadedFor !== slug) return ''
    return slug
  }

  return { shopSlugFor, trackableShop }
}
